var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFida(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5F60C7",
    d: "M11.798 4.14h.416v3.729h-.416zm-3.596 9.759l.219.355l-3.15 1.886l-.214-.351zm7.655.064l-.215.356l3.198 1.915l.214-.351z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedFida0)",
    fillRule: "evenodd",
    d: "M8.142 9.87L12 7.714l3.857 2.156v4.264L12 16.286l-3.858-2.152zm.429.189L12 8.143l3.428 1.916v3.788l-3.424 2.01l-3.433-2.01z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8081EE",
    d: "M11.79 11.876h.415v8.143h-.415z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8081EE",
    d: "m12.257 11.876l-.215.351l-7.075-4.05l.214-.351z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8081EE",
    d: "m11.785 11.876l.215.351l7.071-4.05l-.214-.351z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8081EE",
    fillRule: "evenodd",
    d: "M4.714 7.95L12 3.857l7.285 4.093v8.104L12 20.143l-7.286-4.089zm.428.193L12 4.286l6.857 3.857v7.714L12 19.714l-6.858-3.857z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedFida0",
    x1: 13.861,
    x2: 6.25,
    y1: 2.277,
    y2: 19.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86E0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#259AC1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFida);
export default __webpack_public_path__ + "static/media/fida.d55619fcfac26ccc331a85258c5c632c.svg";
export { ForwardRef as ReactComponent };